export const GUIDED_TOUR_STEP_UI_SETTLE_MS = 180;
export const GUIDED_TOUR_STEP_TRIGGER_PREVIEW_MS = 450;

export const getGuidedTourTestIdSelector = (testId: string) => `[data-testid="${testId}"]`;

export const getGuidedTourMenuPanelSelector = (testId: string) =>
  `${getGuidedTourTestIdSelector(testId)} .MuiPopover-paper`;

export const queryGuidedTourElement = (selector: string) => {
  try {
    return document.querySelector<HTMLElement>(selector);
  } catch {
    return null;
  }
};

export const hasVisibleGuidedTourElement = (selector: string) => {
  if (typeof document === 'undefined') {
    return false;
  }

  const element = queryGuidedTourElement(selector);
  const rect = element?.getBoundingClientRect();

  return Boolean(element && rect && rect.width > 0 && rect.height > 0);
};

export const waitForVisibleGuidedTourElement = (
  selector: string,
  options: { intervalMs?: number; timeoutMs?: number } = {}
) => {
  const { intervalMs = 50, timeoutMs = 2000 } = options;

  return new Promise<void>(resolve => {
    if (typeof window === 'undefined' || hasVisibleGuidedTourElement(selector)) {
      resolve();
      return;
    }

    const startedAt = window.performance.now();
    const intervalId = window.setInterval(() => {
      const hasElement = hasVisibleGuidedTourElement(selector);
      const didTimeout = window.performance.now() - startedAt >= timeoutMs;

      if (hasElement || didTimeout) {
        window.clearInterval(intervalId);
        resolve();
      }
    }, intervalMs);
  });
};

export const waitForGuidedTourUiToSettle = () =>
  new Promise<void>(resolve => {
    window.setTimeout(resolve, GUIDED_TOUR_STEP_UI_SETTLE_MS);
  });

export const closeOpenGuidedTourMenus = async () => {
  document.querySelectorAll<HTMLElement>('.MuiBackdrop-root').forEach(backdrop => {
    backdrop.click();
  });
  document.body.click();
  await waitForGuidedTourUiToSettle();
};

export const clickGuidedTourTarget = async (selector: string, options: { closeOpenMenus?: boolean } = {}) => {
  const { closeOpenMenus = false } = options;

  if (closeOpenMenus) {
    await closeOpenGuidedTourMenus();
  }

  const target = queryGuidedTourElement(selector);

  target?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
  target?.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
  target?.click();
  await waitForGuidedTourUiToSettle();
};
